'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React from 'react';
import { shuffle } from '../../../utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
import UISelectableButton from 'UIComponents/button/UISelectableButton';
import { mapRedirectTargetToRoute } from 'self-service-api/core/utilities/links';
import { getProductNameText } from '../../common/adapters/getProductNameText';
import TrialRedirectSurvey from 'ui-addon-upgrades/_core/trial/activation/TrialRedirectSurvey';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import SuccessModal from '../../common/components/activation/SuccessModal';
import { navigateTo } from '../../common/navigation/url';
var LANG_ROUTE = 'upgrades.activationModal.new';
var OPTIONS = {
  CREATE_NEW_USERS: 'createNewUsers',
  SPECIFIC_FEATURE: 'specificFeature',
  EXPLORE_ON_YOUR_OWN: 'exploreOnYourOwn'
};
var shuffledOptions = shuffle(Object.values(OPTIONS));

var TrialActivationNextStepsModal = /*#__PURE__*/function (_React$Component) {
  _inherits(TrialActivationNextStepsModal, _React$Component);

  function TrialActivationNextStepsModal(props) {
    var _this;

    _classCallCheck(this, TrialActivationNextStepsModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TrialActivationNextStepsModal).call(this, props));

    _this.handleOptionClick = function (option) {
      var _this$props = _this.props,
          upgradeData = _this$props.upgradeData,
          upgradeProduct = _this$props.upgradeData.upgradeProduct;

      switch (option) {
        case OPTIONS.CREATE_NEW_USERS:
          tracker.trackBeforeUnload('trialActivationInteraction', Object.assign({
            action: 'clicked create new users'
          }, upgradeData));
          navigateTo(mapRedirectTargetToRoute('user-settings'));
          break;

        case OPTIONS.SPECIFIC_FEATURE:
          tracker.track('trialActivationInteraction', Object.assign({
            action: 'clicked try out a specific feature'
          }, upgradeData));

          _this.setState({
            showRedirectSurvey: true
          });

          break;

        case OPTIONS.EXPLORE_ON_YOUR_OWN:
          tracker.trackBeforeUnload('trialActivationInteraction', Object.assign({
            action: 'clicked explore on my own'
          }, upgradeData));
          navigateTo(mapRedirectTargetToRoute('other', upgradeProduct));
          break;

        default:
          break;
      }
    };

    _this.state = {
      showRedirectSurvey: false
    };
    return _this;
  }

  _createClass(TrialActivationNextStepsModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          upgradeProduct = _this$props2.upgradeData.upgradeProduct,
          upgradeData = _this$props2.upgradeData;
      var showRedirectSurvey = this.state.showRedirectSurvey;
      var productName = getProductNameText(upgradeProduct);

      if (showRedirectSurvey) {
        return React.createElement(SuccessModal, {
          header: React.createElement(FormattedMessage, {
            message: LANG_ROUTE + ".redirectModal.header"
          }),
          footer: React.createElement(TrialRedirectSurvey, {
            upgradeData: upgradeData
          })
        });
      }

      return React.createElement(SuccessModal, {
        header: React.createElement(FormattedMessage, {
          message: LANG_ROUTE + ".successModal.thanksForActivatingTrial"
        }),
        footer: React.createElement("div", null, React.createElement(FormattedMessage, {
          message: LANG_ROUTE + ".successModal.subHeader",
          options: {
            productName: productName
          }
        }), React.createElement("div", {
          className: "text-left m-top-6",
          style: {
            width: '100%'
          }
        }, React.createElement("h5", null, React.createElement(FormattedMessage, {
          message: LANG_ROUTE + ".successModal.firstAction"
        })), React.createElement(UIList, null, shuffledOptions.map(function (option) {
          return React.createElement(UISelectableButton, {
            className: "m-bottom-2 display-inline-block text-left",
            textLabel: React.createElement(FormattedMessage, {
              message: LANG_ROUTE + ".successModal.actions." + option
            }),
            block: true,
            name: "other",
            truncatable: false,
            onClick: function onClick() {
              return _this2.handleOptionClick(option);
            },
            key: option
          });
        }))))
      });
    }
  }]);

  return TrialActivationNextStepsModal;
}(React.Component);

export default TrialActivationNextStepsModal;